<div class="expense-entry-feature">
    <ef-loading-container
        [observables]="[
            tasks$,
            locales$,
            travelModes$,
            tripLegTypes$,
            userPaymentMethods$
        ]"
    ></ef-loading-container>

    <ef-expense-entry
        [travelTypeId]="travelTypeId"
        [canEdit]="canEdit"
        [reportDateEnabled]="reportDateEnabled"
        [purposeRequired]="purposeRequired"
        [receiptDescriptionRequired]="receiptDescriptionRequired"
        [saving]="saving"
        [summary]="summary"
        [detail]="detail"
        [minDate]="minDate$ | async"
        [maxDate]="maxDate$ | async"
        [tasks]="tasks$ | async"
        [expenseTasks]="expenseTasks$ | async"
        [expenseItems]="expenseItems$ | async"
        [locales]="locales$ | async"
        [perDiemTypes]="perDiemTypes$ | async"
        [tripLegTypes]="tripLegTypes$ | async"
        [travelModes]="travelModes$ | async"
        [travelRates]="travelRates$ | async"
        [selectedMileageRate]="selectedMileageRate$ | async"
        [userPaymentMethods]="userPaymentMethods$ | async"
        [userInfo]="userInfo"
        [successMessage]="successMessage"
        [failureMessage]="failureMessage"
        (save)="onSave($event)"
        (cancel)="onCancel()"
        (travelRatesNeeded)="onTravelRatesNeeded($event)"
    ></ef-expense-entry>
</div>
